import Vue from "vue";

export default {
    PROCCESS_RES: (state, data) => {
        const { type } = data;

        state[type].items = data.items.map(it => {
            if (it.user.establishmentAddress) {
                it.user.establishmentAddress.place = Vue.filter('extendAddress')(it.user.establishmentAddress.place);
            }

            return Object.reject(
                Object.assign({}, it, it.user),
                ['user']
            );
        });

        state[type].pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1,
            count: data.count || 0
        };
    },

    SET_CLIENTS_QUERY: (state, query) => {
        state.clients.filters.query = query;
    },

    SET_OPERATORS_QUERY: (state, query) => {
        state.operators.filters.query = query;
    },

    SET_OPERATORS_FILTER_BY: (state, filterBy) => {
        state.operators.filters.filterBy = filterBy;
    },

    SET_OPERATORS_ROLE_NAME: (state, roleName)  => {
        state.operators.filters.roleName = roleName;
    },

    SET_OPERATORS_START_DATE: (state, startDate) => {
        state.operators.filters.startDate = startDate;
    },

    SET_OPERATORS_END_DATE: (state, endDate) => {
        state.operators.filters.endDate = endDate;
    },

    SET_DRIVERS_QUERY: (state, query) => {
        state.drivers.filters.query = query;
    },

    SET_DRIVERS_FILTER_BY: (state, filterBy) => {
        state.drivers.filters.filterBy = filterBy;
    },

    SET_DRIVERS_START_DATE: (state, startDate) => {
        state.drivers.filters.startDate = startDate;
    },

    SET_DRIVERS_END_DATE: (state, endDate) => {
        state.drivers.filters.endDate = endDate;
    },

    SET_DRIVERS_BRAND_ID: (state, brandId) => {
        state.drivers.filters.brandId = brandId;
    },

    SET_DRIVERS_COMMISSION_ID: (state, commissionId) => {
        state.drivers.filters.commissionId = commissionId;
    },

    RESET_DRIVERS_FILTERS: (state) => {
        state.drivers.filters = {
            query: '',
            brandId: null,
            filterBy: null,
            startDate: null,
            endDate: null,
            commissionId: null
        };
    },

    RESET_OPERATORS_FILTERS: (state) => {
        state.operators.filters = {
            query: '',
            filterBy: null,
            startDate: null,
            endDate: null,
            roleName: null
        };
    },

    RESET_CLIENTS_FILTERS: (state) => {
        state.clients.filters = {
            query: ''
        };
    }
};
